import React, { useEffect } from 'react'
import Card from "../Card/Card";

import styles from './SubscriberChangePaymentMethod.module.scss'

import { useForm, Controller } from 'react-hook-form'
import { useState } from "react";
import { Typography } from '@mui/material';
import { Box, Button, Grid } from "@mui/material";
import { Autocomplete, MenuItem, FormHelperText, Radio, TextField, FormControlLabel, Checkbox, InputAdornment, RadioGroup, FormLabel, FormControl } from '@mui/material';
import UploadIcon from '../../assets/uploadIcon.svg'
import Bank from '../../assets/Bank.svg'
import CreditCard from '../../assets/CreditCard.svg'
import SendRequest from "../../request/SendRequest";
import Dialog from '@mui/material/Dialog';
import { CloseButton } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const SubscriberChangePaymentMethod = ({
    paymentMethodData,
    availableBanks,
    edit,
    setEdit,
    targetPaymentMethod,
    userInfoData,
    setNoticeDialogOpen,
    loading,
    setLoading,
    setSnackBar,
}) => {

    const { t } = useTranslation();
    const [comfirmDialogOpen, setComfirmDialogOpen] = useState(false)
    const handleClose = () => {
        setComfirmDialogOpen(false)
    }
    const [emailChangedDialogOpen, setEmailChangedDialogOpen] = useState(false)
    const handleEmailChangedDialogClose = () => {
        setEmailChangedDialogOpen(false)
    }

    const {
        register,
        setError,
        clearErrors,
        getValues,
        setValue,
        reset,
        handleSubmit,
        watch,
        control,
        formState: { errors },
    } = useForm({
        defaultValues: {
            authorizationInfo: {
                type: "firstParty", //firstParty || thirdParty
                subscriptionUserNames: paymentMethodData.subscriptionUserNames || "",
                firstPartyStatementAccepted: false,
                name: "",
                hkid: "",
                idDocument: null,
                thirdPartyStatementAccepted: false,
            },
            subscriptionCustomerNos: paymentMethodData.subscriptionCustomerNos || "",
            paymentMethod: targetPaymentMethod || "creditCard",
            creditCardInfo: {
                cardType: "visa",
                creditCardNumber: "",
                cardNumber1: "",
                cardNumber2: "",
                cardNumber3: "",
                cardNumber4: "",
                cardOwner: "",
                cardExpiryDate: "",
                cardOwnerMobile: "",
            },
            bankInfo: {
                bankAcName: "",
                bankOption: "渣打銀行_003",
                bankName: "",
                bankCode: "",
                branchCode: "",
                bankAcNumber: "",
                mobilePhone: "",
            },
            emailAddress: ""
        }
    })

    // Get last 3 digits of the bankOption
    const bankCode = watch('bankInfo.bankOption').slice(-3);

    // Only bankCode is changed, set bankCode to bankInfo.bankAcNumber
    useEffect(() => {
        setValue('bankInfo.bankAcNumber', bankCode);
    }, [bankCode, setValue]);

    // [creditCard, bankTransfer]
    const [paymentMethod, setPaymentMethod] = useState(targetPaymentMethod || "creditCard")
    const changePaymentMethod = (e) => {
        console.log('changePaymentMethod', e.target.value)
        setPaymentMethod(e.target.value)
        setValue('paymentMethod', e.target.value)
    }
    // [firstParty, thirdParty]
    const [authorizationInfoType, setAuthorizationInfoType] = useState('firstParty')
    const changeAuthorizationInfoType = (e) => {
        setAuthorizationInfoType(e.target.value)
        setValue('authorizationInfo.type', e.target.value)
    }

    var hasErrorInConfirmDialog = false

    const onSubmit = data => {
        clearErrors()
        hasErrorInConfirmDialog = false
        setLoading(true)

        const formData = new FormData();
        formData.append("paymentMethod", data.paymentMethod)
        if (data.paymentMethod === "creditCard") {
            formData.append("creditCardInfo[cardType]", data.creditCardInfo.cardType)
            formData.append("creditCardInfo[creditCardNumber]", data.creditCardInfo.creditCardNumber)
            formData.append("creditCardInfo[cardNumber1]", data.creditCardInfo.creditCardNumber.slice(0, 4))
            formData.append("creditCardInfo[cardNumber2]", data.creditCardInfo.creditCardNumber.slice(4, 8))
            formData.append("creditCardInfo[cardNumber3]", data.creditCardInfo.creditCardNumber.slice(8, 12))
            formData.append("creditCardInfo[cardNumber4]", data.creditCardInfo.creditCardNumber.slice(12))
            formData.append("creditCardInfo[cardOwner]", data.creditCardInfo.cardOwner)
            formData.append("creditCardInfo[cardExpiryDate]", data.creditCardInfo.cardExpiryDate)
            formData.append("creditCardInfo[cardOwnerMobile]", data.creditCardInfo.cardOwnerMobile)
        }
        if (data.paymentMethod === "bankTransfer") {
            formData.append("bankInfo[bankAcName]", data.bankInfo.bankAcName)
            formData.append("bankInfo[bankName]", data.bankInfo.bankOption || null)
            formData.append("bankInfo[bankAcNumber]", data.bankInfo.bankAcNumber.replace(/\D/g, ''))
            formData.append("bankInfo[mobilePhone]", data.bankInfo.mobilePhone)
        }
        formData.append("authorizationInfo[type]", data.authorizationInfo.type)
        formData.append("authorizationInfo[subscriptionUserNames]", data.authorizationInfo.subscriptionUserNames)
        if (data.authorizationInfo.type === "firstParty") {
            formData.append("authorizationInfo[firstPartyStatementAccepted]", data.authorizationInfo.firstPartyStatementAccepted)
        }
        if (data.authorizationInfo.type === "thirdParty") {
            formData.append("authorizationInfo[name]", data.authorizationInfo.name)
            formData.append("authorizationInfo[hkid]", data.authorizationInfo.hkid)
            formData.append("authorizationInfo[thirdPartyStatementAccepted]", data.authorizationInfo.thirdPartyStatementAccepted)
            const idDocumentInput = document.querySelector('input[name="authorizationInfo.idDocument"]');
            if (idDocumentInput && idDocumentInput.files?.length > 0 && idDocumentInput.files[0].size > 0) {
                formData.append("authorizationInfo[idDocument]", idDocumentInput.files[0]);
            }
        }
        formData.append("subscriptionCustomerNos", data.subscriptionCustomerNos)
        formData.append("emailAddress", data.emailAddress)

        SendRequest.post({
            headers: { 'Content-Type': 'multipart/form-data' },
            url: process.env.REACT_APP_API_URL + 'subscriber/paymentMethod',
            data: formData
        }).then(response => {
            if (response.status === 200) {
                setEdit(!edit)
                setNoticeDialogOpen(true)
                setSnackBar({
                    open: true,
                    message: response.data.data.message ?? t("submit_success"),
                    severity: "success",
                })
            }
        }).catch(err => {
            if (err.response?.status === 422) {
                Object.keys(err.response?.data?.errors).map((key) => {
                    setError(key, { message: err.response?.data?.errors[key] })
                })
                if (err.response?.data?.errors.hasOwnProperty('emailAddress')) {
                    hasErrorInConfirmDialog = true
                }
                if (err.response?.data?.errors.hasOwnProperty('creditCardInfo.cardNumber1') || err.response?.data?.errors.hasOwnProperty('creditCardInfo.cardNumber2') || err.response?.data?.errors.hasOwnProperty('creditCardInfo.cardNumber3') || err.response?.data?.errors.hasOwnProperty('creditCardInfo.cardNumber4')) {
                    setError('creditCardInfo.creditCardNumber', { message: err.response?.data?.errors['creditCardInfo.cardNumber1'] || err.response?.data?.errors['creditCardInfo.cardNumber2'] || err.response?.data?.errors['creditCardInfo.cardNumber3'] || err.response?.data?.errors['creditCardInfo.cardNumber4'] })
                    clearErrors("creditCardInfo.cardNumber1");
                    clearErrors("creditCardInfo.cardNumber2");
                    clearErrors("creditCardInfo.cardNumber3");
                    clearErrors("creditCardInfo.cardNumber4");
                }
                if (Object.keys(err.response?.data?.errors).length > 0) {
                    setTimeout(() => {
                        let firstErrorField = Object.keys(err.response?.data?.errors)[0];
                        if (firstErrorField === "creditCardInfo.cardNumber1" || firstErrorField === "creditCardInfo.cardNumber2" || firstErrorField === "creditCardInfo.cardNumber3" || firstErrorField === "creditCardInfo.cardNumber4") {
                            firstErrorField = "creditCardInfo.creditCardNumber";
                        }
                        const input = document.querySelector(
                            `form[name="payment-method-form"] input[name="${firstErrorField.replace(/\./g, '\\.')}"]`
                        );
                        if (input) {
                            input.scrollIntoView({
                                behavior: 'smooth',
                                block: 'center',
                            });
                        }
                    }, 500)
                }
            } else if (err.response?.status === 400) {
                setSnackBar({
                    open: true,
                    message: err.response?.data?.message ?? t("submit_fail"),
                    severity: "error",
                })
            } else {
                setSnackBar({
                    open: true,
                    message: t("system_busy"),
                    severity: "error",
                })
            }
        }).finally(() => {
            setLoading(false)
            if (!hasErrorInConfirmDialog) {
                handleClose()
            }
            handleEmailChangedDialogClose()
        })
    };

    const onInvalid = (errors) => console.error('onInvalid',errors)
    const checkEmailAddressChanged = () => {
        const emailAddress = getValues('emailAddress')
        if (emailAddress !== userInfoData.emailAddress) {
            setComfirmDialogOpen(true)
            setEmailChangedDialogOpen(true)
        } else {
            clearErrors("creditCardInfo.creditCardNumber");
            handleSubmit(onSubmit, onInvalid)()
        }
    }

    return (
        <>
            <Box>
                <form name="payment-method-form" onSubmit={handleSubmit(onSubmit)}>
                    <Box display={"flex"} flexDirection={"column"} gap={"12px"} marginBottom={"32px"}>
                        <Typography variant="h2" fontSize={14} fontWeight={500} color={"rgba(67, 71, 78, 1)"} textAlign={"left"}  >繳費授權</Typography>
                        <Card fullWidth={true}>
                            <Box fullWidth={true} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                                <Grid container maxWidth={355} spacing={2} justifyContent="center" alignItems="center">
                                    <Grid xs={12} item display={"flex"} flexDirection={"row"} gap={"20px"}>
                                        <Button
                                            style={{
                                                borderColor: authorizationInfoType == "firstParty" ? "#ff395d" : "#eaeaea",
                                                borderRadius: 10, textAlign: "left", padding: "14px 15px", color: "rgba(102, 102, 102, 1)"
                                            }}
                                            fullWidth={true}
                                            value="firstParty"
                                            onClick={changeAuthorizationInfoType}
                                        >
                                            服務訂戶或使用者
                                        </Button>
                                        <Button
                                            style={{
                                                borderColor: authorizationInfoType == "thirdParty" ? "#ff395d" : "#eaeaea",
                                                borderRadius: 10, textAlign: "left", padding: "14px 15px", color: "rgba(102, 102, 102, 1)"
                                            }}
                                            value="thirdParty"
                                            onClick={changeAuthorizationInfoType}
                                            fullWidth={true}
                                        >
                                            第三方身份授權
                                        </Button>
                                    </Grid>
                                    {authorizationInfoType == "firstParty" &&
                                        <>
                                            <Grid xs={12} item>
                                                <Controller
                                                    name="authorizationInfo.subscriptionUserNames"
                                                    control={control}
                                                    // rules={{
                                                    //     required: "服務訂戶或服務使用者姓名為必填項目"
                                                    // }}
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            fullWidth
                                                            variant="filled"
                                                            label="服務訂戶或服務使用者姓名"
                                                            error={!!errors.authorizationInfo?.subscriptionUserNames}
                                                            helperText={errors.authorizationInfo?.subscriptionUserNames ? errors.authorizationInfo?.subscriptionUserNames.message : ""}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                            <Grid xs={12} item>
                                                <Controller
                                                    name="authorizationInfo.firstPartyStatementAccepted"
                                                    control={control}
                                                    // rules={{
                                                    //     validate: (value) => value === true || "此項目為必填項目"
                                                    // }}
                                                    render={({ field: props }) => (
                                                        <>
                                                            <FormControlLabel
                                                                className={`${styles["customer-checkbox"]}`}
                                                                error={!!errors.authorizationInfo?.firstPartyStatementAccepted}
                                                                control={
                                                                    <div style={{ alignSelf: "start" }} className={`${props.value == true ? styles["checked"] : ""} ${errors.authorizationInfo?.firstPartyStatementAccepted ? styles["error"] : ""}`}>
                                                                        <Checkbox
                                                                            style={{ padding: "0 12px 0 0" }}
                                                                            {...props}
                                                                            checked={props.value}
                                                                            onChange={(e) => props.onChange(e.target.checked)}
                                                                        />
                                                                    </div>
                                                                }
                                                                label={<span style={{ color: "#43474E", fontSize: "14px" }}>本人現授權予長者安居協會在本人的指定銀行或信用卡扣除長者安居協會平安鐘服務相關費用。</span>}
                                                            />
                                                            {!!errors.authorizationInfo?.firstPartyStatementAccepted &&
                                                                <FormHelperText error={true} style={{ marginLeft: "14px" }} >{errors.authorizationInfo?.firstPartyStatementAccepted ? errors.authorizationInfo?.firstPartyStatementAccepted.message : ""}</FormHelperText>
                                                            }
                                                        </>

                                                    )}
                                                />
                                            </Grid>
                                        </>
                                    }
                                    {authorizationInfoType == "thirdParty" &&
                                        <>
                                            <Grid xs={12} item>
                                                <Typography variant='h3' textAlign={"left"} fontSize={14} fontWeight={500} color="#43474E">第三方身份授權</Typography>
                                            </Grid>
                                            <Grid xs={12} item>
                                                <Controller
                                                    name="authorizationInfo.name"
                                                    control={control}
                                                    // rules={{
                                                    //     required: "姓名為必填項目"
                                                    // }}
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            fullWidth
                                                            variant="filled"
                                                            label="姓名"
                                                            error={!!errors.authorizationInfo?.name}
                                                            helperText={errors.authorizationInfo?.name ? errors.authorizationInfo?.name.message : ""}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                            <Grid xs={12} item>
                                                <Controller
                                                    name="authorizationInfo.hkid"
                                                    control={control}
                                                    // rules={{
                                                    //     required: "身份證號碼為必填項目"
                                                    // }}
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            fullWidth
                                                            variant="filled"
                                                            label="身份證號碼 A1234567(8)"
                                                            error={!!errors.authorizationInfo?.hkid}
                                                            helperText={errors.authorizationInfo?.hkid ? errors.authorizationInfo?.hkid?.message : ""}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                            <Grid xs={12} item>
                                                <Controller
                                                    name="authorizationInfo.idDocument"
                                                    control={control}
                                                    // rules={{
                                                    //     required: "身份證明文件碼為必上傳項目"
                                                    // }}
                                                    render={({ field }) => (
                                                        <>
                                                            <label className={`${styles["file-input"]} ${errors.authorizationInfo?.idDocument && styles["error"]}`}>
                                                                <Box display={"flex"} flexDirection={"row"} width={"100%"} padding={"15px"}>
                                                                    <Box width={"100%"} maxWidth={260}>
                                                                        <Typography sx={{ textOverflow: "ellipsis", whiteSpace: 'nowrap', overflow: 'hidden', textAlign:'left' }} fontSize={15} color={"#43474E"}>{field.value ? field.value?.split('\\').pop().split('/').pop() : "上傳身份證明文件"}</Typography>
                                                                    </Box>
                                                                    <img src={UploadIcon} style={{ width: '24px', height: '24px', marginLeft: 'auto' }} />
                                                                </Box>
                                                                <input type='file' hidden {...field} accept=".pdf,.jpg,.jpeg,.png"/>
                                                            </label>
                                                            <FormHelperText style={{ marginLeft: "14px", marginRight: "14px" }} error={true}>{errors.authorizationInfo?.idDocument ? errors.authorizationInfo?.idDocument?.message : ""}</FormHelperText>
                                                        </>
                                                    )}
                                                />
                                            </Grid>
                                            <Grid xs={12} item>
                                                <Typography fontSize={13} color={"#43474E"} textAlign={"left"}>
                                                    如以第三方身份授權指定銀行戶口或信用卡作授權轉賬，第三方必須提供身份證副本作申請之用。
                                                </Typography>
                                            </Grid>
                                            <Grid xs={12} item>
                                                <Typography variant='h3' textAlign={"left"} fontSize={14} fontWeight={500} color="#43474E">有關服務訂戶或服務使用者</Typography>
                                            </Grid>
                                            <Grid xs={12} item>
                                                <Controller
                                                    name="authorizationInfo.subscriptionUserNames"
                                                    control={control}
                                                    // rules={{
                                                    //     required: "服務訂戶或服務使用者姓名為必填項目"
                                                    // }}
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            fullWidth
                                                            variant="filled"
                                                            label="姓名"
                                                            error={!!errors.authorizationInfo?.subscriptionUserNames}
                                                            helperText={errors.authorizationInfo?.subscriptionUserNames ? errors.authorizationInfo?.subscriptionUserNames.message : ""}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                            <Grid xs={12} item>
                                                <Controller
                                                    name="authorizationInfo.thirdPartyStatementAccepted"
                                                    control={control}
                                                    // rules={{
                                                    //     validate: (value) => value === true || "此項目為必填項目"
                                                    // }}
                                                    render={({ field: props }) => (
                                                        <>
                                                            <FormControlLabel
                                                                className={`${styles["customer-checkbox"]}`}
                                                                error={!!errors.authorizationInfo?.thirdPartyStatementAccepted}
                                                                control={
                                                                    <div style={{ alignSelf: "start" }} className={`${props.value == true ? styles["checked"] : ""} ${errors.thirdparty_subscriberAuthoriseSCHSA ? styles["error"] : ""}`}>
                                                                        <Checkbox
                                                                            style={{ padding: "0 12px 0 0" }}
                                                                            {...props}
                                                                            checked={props.value}
                                                                            onChange={(e) => props.onChange(e.target.checked)}
                                                                        />
                                                                    </div>
                                                                }
                                                                label={<span style={{ color: "#43474E", fontSize: "14px" }}>本人同意以第三方身份授權予長者安居協在長者安居協會在本人的指定銀行或信用卡扣除有關服務訂戶或服務使用者平安鐘服務使用期間的相關費用。</span>}
                                                            />
                                                            {!!errors.authorizationInfo?.thirdPartyStatementAccepted &&
                                                                <FormHelperText error={true} style={{ marginLeft: "14px" }} >{errors.authorizationInfo?.thirdPartyStatementAccepted ? errors.authorizationInfo?.thirdPartyStatementAccepted.message : ""}</FormHelperText>
                                                            }
                                                        </>

                                                    )}
                                                />
                                            </Grid>
                                        </>
                                    }
                                </Grid>
                            </Box>
                        </Card>
                        <Typography variant="h2" fontSize={14} fontWeight={500} color={"rgba(67, 71, 78, 1)"} textAlign={"left"}  >繳費方式</Typography>
                        <Card fullWidth={true}>
                            <Box fullWidth={true} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                                <Grid container maxWidth={355} spacing={2} justifyContent="center" alignItems="center">
                                    <Grid xs={12} item display={"flex"} flexDirection={"row"} gap={"20px"}>
                                        <Button
                                            style={{
                                                borderColor: paymentMethod == "creditCard" ? "#ff395d" : "#eaeaea",
                                                borderRadius: 10, textAlign: "left", padding: "14px 15px", color: "rgba(102, 102, 102, 1)",
                                                display: 'flex', justifyContent: 'start', gap: "12px"
                                            }}
                                            value="creditCard"
                                            onClick={changePaymentMethod}
                                            fullWidth={true}
                                        >
                                            <Box width={38} height={38} borderRadius={"12px"} style={{ backgroundColor: "#FFF3F6" }} display={"flex"} justifyContent={"center"} alignItems={"center"} onClick={(e) => e.stopPropagation()}>
                                                <img src={CreditCard} style={{ width: '24px', height: '24px' }} />
                                            </Box>
                                            信用卡
                                        </Button>
                                        <Button
                                            style={{
                                                borderColor: paymentMethod == "bankTransfer" ? "#ff395d" : "#eaeaea",
                                                borderRadius: 10, textAlign: "left", padding: "14px 15px", color: "rgba(102, 102, 102, 1)",
                                                display: 'flex', justifyContent: 'start', gap: "12px"
                                            }}
                                            value="bankTransfer"
                                            onClick={changePaymentMethod}
                                            fullWidth={true}
                                        >
                                            <Box width={38} height={38} borderRadius={"12px"} style={{ backgroundColor: "#FFF3F6" }} display={"flex"} justifyContent={"center"} alignItems={"center"} onClick={(e) => e.stopPropagation()}>
                                                <img src={Bank} style={{ width: '24px', height: '24px' }} />
                                            </Box>
                                            銀行戶口
                                        </Button>
                                    </Grid>
                                    {
                                        paymentMethod === "creditCard" &&
                                        <>
                                            <Grid item xs={12}>
                                                <Box border={"1px solid #EAEAEA"} padding={"8px 16px"} borderRadius={"12px"}>
                                                    <FormControl fullWidth sx={{ ".MuiFormLabel-root.Mui-focused": { color: "#999999" } }}>
                                                        <FormLabel style={{ textAlign: 'left', fontSize: "12px" }} className='testing'>信用卡類別</FormLabel>
                                                        <Controller
                                                            name={"creditCardInfo.cardType"}
                                                            // rules={{ required: "服務訂戶或服務使用者姓名為必填項目" }}
                                                            control={control}
                                                            render={({ field }) => (
                                                                <RadioGroup {...field}>
                                                                    <FormControlLabel value="visa" control={<Radio sx={{ color: '#B5B5B5', '&.Mui-checked': { color: '#FF395D' } }} />} label="Visa" />
                                                                    <FormControlLabel value="master" control={<Radio sx={{ color: '#B5B5B5', ' &.Mui-checked': { color: '#FF395D' } }} />} label="Mastercard" />
                                                                </RadioGroup>
                                                            )}
                                                        />
                                                    </FormControl>
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Controller
                                                    name="creditCardInfo.creditCardNumber"
                                                    control={control}
                                                    // rules={{
                                                    //     required: "信用卡號碼為必填項目",
                                                    //     validate: (value) => /^\d{16}$/.test(value) || "信用卡號碼必須為16位數字"
                                                    // }}
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            fullWidth
                                                            variant="filled"
                                                            label="信用卡號碼"
                                                            onChange={(e) => {
                                                                const value = e.target.value.replace(/\D/g, '').slice(0, 16); // Remove non-digits and limit to 8 digits
                                                                // const formattedValue = value.length > 4 ? `${value.slice(0, 4)} ${value.slice(4)}` : value; // Add space after 4th digit
                                                                field.onChange(value); // Save the value without space
                                                            }}

                                                            value={field.value?.replace(/\D/g, '').replace(/(.{4})/g, '$1 ').trim() || field.value}

                                                            error={!!errors.creditCardInfo?.creditCardNumber}
                                                            helperText={errors.creditCardInfo?.creditCardNumber ? errors.creditCardInfo?.creditCardNumber.message : ""}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Controller
                                                    name="creditCardInfo.cardOwner"
                                                    control={control}
                                                    // rules={{
                                                    //     required: "持卡人英文姓名為必填項目"
                                                    // }}
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            fullWidth
                                                            variant="filled"
                                                            label="持卡人英文姓名"
                                                            error={!!errors.creditCardInfo?.cardOwner}
                                                            helperText={errors.creditCardInfo?.cardOwner ? errors.creditCardInfo?.cardOwner.message : ""}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Controller
                                                    name="creditCardInfo.cardExpiryDate"
                                                    control={control}
                                                    defaultValue=""
                                                    // rules={{
                                                    //     required: "到期日為必填項目",
                                                    //     validate: validateExpiryDate
                                                    // }}
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            fullWidth
                                                            label="到期日 (mm/yy)"
                                                            variant="filled"
                                                            placeholder="MM/YY"
                                                            onChange={(e) => {
                                                                const value = e.target.value.replace(/\D/g, '').slice(0, 4); // Remove non-digits
                                                                const formattedValue = value?.length > 2 ? `${value?.slice(0, 2)}/${value.slice(2)}` : value;
                                                                field.onChange(formattedValue); // Save the value without space
                                                                // e.target.value = formattedValue; // Add space for display
                                                            }}
                                                            error={!!errors.creditCardInfo?.cardExpiryDate}
                                                            helperText={errors.creditCardInfo?.cardExpiryDate ? errors.creditCardInfo?.cardExpiryDate.message : null}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Controller
                                                    name="creditCardInfo.cardOwnerMobile"
                                                    control={control}
                                                    // rules={{
                                                    //     required: "持卡人之聯絡電話號碼為必填項目",
                                                    //     validate: (value) => /^\d{8}$/.test(value) || "電話號碼必須為8位數字"
                                                    // }}
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            fullWidth
                                                            variant="filled"
                                                            label="持卡人之聯絡電話號碼"
                                                            onChange={(e) => {
                                                                const value = e.target.value.replace(/\D/g, '').slice(0, 8); // Remove non-digits and limit to 8 digits
                                                                // const formattedValue = value.length > 4 ? `${value.slice(0, 4)} ${value.slice(4)}` : value; // Add space after 4th digit
                                                                field.onChange(value); // Save the value without space
                                                            }}
                                                            value={field.value?.length > 4 ? `${field.value?.slice(0, 4)} ${field.value?.slice(4)}` : field.value}

                                                            error={!!errors.creditCardInfo?.cardOwnerMobile}
                                                            helperText={errors.creditCardInfo?.cardOwnerMobile ? errors.creditCardInfo?.cardOwnerMobile.message : ""}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                        </>
                                    }

                                    {
                                        paymentMethod === "bankTransfer" &&
                                        <>
                                            <Grid item xs={12}>
                                                <Controller
                                                    name="bankInfo.bankAcName"
                                                    control={control}
                                                    // rules={{
                                                    //     required: '結單/存摺上的英文姓名為必填項目'
                                                    // }}
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            fullWidth
                                                            variant="filled"
                                                            label="結單/存摺上的英文姓名"
                                                            error={!!errors.bankInfo?.bankAcName}
                                                            helperText={errors.bankInfo?.bankAcName ? errors.bankInfo?.bankAcName.message : ""}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Controller
                                                    name="bankInfo.bankOption"
                                                    control={control}
                                                    // rules={{
                                                    //     required: '銀行名稱為必填項目'
                                                    // }}
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            select
                                                            fullWidth
                                                            variant="filled"
                                                            label="銀行名稱"
                                                            error={!!errors.bankInfo?.bankOption}
                                                            helperText={errors.bankInfo?.bankOption ? errors.bankInfo?.bankOption.message : ""}
                                                            sx={{ ' .MuiSelect-select': { padding: '25px 12px 8px !important', textAlign: 'left', textWrap:'auto' } }}
                                                        >
                                                            {
                                                                availableBanks.map((bankItem, index) => {
                                                                    return (
                                                                        <MenuItem key={index} value={`${bankItem.bankName}_${bankItem.bankCode.join(', ')}`}>
                                                                            {`${bankItem.bankName} (${bankItem.bankCode.join(', ')})`}
                                                                        </MenuItem>
                                                                    )
                                                                })
                                                            }
                                                        </TextField>

                                                    )}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Controller
                                                    name="bankInfo.bankAcNumber"
                                                    control={control}
                                                    // rules={{
                                                    //     required: '銀行戶口號碼為必填項目'
                                                    // }}
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            fullWidth
                                                            variant="filled"
                                                            label="銀行戶口號碼"
                                                            onChange={(e) => {
                                                                let value = e.target.value.replace(/\D/g, '') // Remove non-digits
                                                                // If the value does not start with the bank code, set it to the bank code
                                                                // UI is to always show the bank code and the user cannot delete it
                                                                // Because bankCode might be changed here, declaration use let, not const
                                                                if (!value.startsWith(bankCode)) {
                                                                    value = bankCode;
                                                                }
                                                                value = value.slice(0, 16); // Limit to 16 digits
                                                                const formattedValue = value
                                                                    .replace(/(\d{3})(\d)/, '$1 - $2') // Add first dash
                                                                    .replace(/(\d{3})(\d)/, '$1 - $2') // Add second dash
                                                                    .trim();
                                                                field.onChange(formattedValue);
                                                            }}
                                                            error={!!errors.bankInfo?.bankAcNumber}
                                                            helperText={errors.bankInfo?.bankAcNumber ? errors.bankInfo?.bankAcNumber.message : ""}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Controller
                                                    name="bankInfo.mobilePhone"
                                                    control={control}
                                                    // rules={{
                                                    //     required: "銀行戶口之聯絡電話號碼為必填項目",
                                                    //     validate: (value) => /^\d{8}$/.test(value) || "電話號碼必須為8位數字"
                                                    // }}
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            fullWidth
                                                            variant="filled"
                                                            label="銀行戶口之聯絡電話號碼(必須與現時銀行之紀錄相符)"
                                                            onChange={(e) => {
                                                                const value = e.target.value.replace(/\D/g, '').slice(0, 8); // Remove non-digits and limit to 8 digits
                                                                // const formattedValue = value.length > 4 ? `${value.slice(0, 4)} ${value.slice(4)}` : value; // Add space after 4th digit
                                                                field.onChange(value); // Save the value without space
                                                            }}
                                                            value={field.value?.length > 4 ? `${field.value?.slice(0, 4)} ${field.value?.slice(4)}` : field.value}
                                                            error={!!errors.bankInfo?.mobilePhone}
                                                            helperText={errors.bankInfo?.mobilePhone ? errors.bankInfo?.mobilePhone.message : ""}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                        </>
                                    }
                                </Grid>
                            </Box>
                        </Card>
                        <Box fullWidth={true} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                            <Grid container maxWidth={355} spacing={2} justifyContent="center" alignItems="center">
                                <Grid xs={12} item>
                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        label="客戶編號(只適用於現有客戶)"
                                        disabled
                                        inputProps={{ readOnly: true }}
                                        value={paymentMethodData.subscriptionCustomerNos}
                                    />
                                </Grid>
                                <Grid xs={12} item>
                                    <ol>
                                        <li>
                                            <Typography textAlign={"left"} fontSize={13} color={"#43474E"}>本人現授權本人的指定銀行或信用卡發卡機構，自本人的賬戶內轉賬予長者安居協會。惟每次轉賬金額不得多於港幣$1000。</Typography>
                                        </li>
                                        <li>
                                            <Typography textAlign={"left"} fontSize={13} color={"#43474E"}>本人同意本人的銀行或信用卡發卡機構毋須證實該等轉賬通知是否已交予本人。</Typography>
                                        </li>
                                        <li>
                                            <Typography textAlign={"left"} fontSize={13} color={"#43474E"}>如因該等轉賬而令本人的賬戶出現透支，本人願意承擔全部責任。</Typography>
                                        </li>
                                        <li>
                                            <Typography textAlign={"left"} fontSize={13} color={"#43474E"}>本人同意會通知長者安居協會任何賬戶的變更或取消交費方式。</Typography>
                                        </li>
                                        <li>
                                            <Typography textAlign={"left"} fontSize={13} color={"#43474E"}>本人明白須在指定的轉賬日期前一個辦公日，在賬戶内備有足夠存款或信用額以便支付該等授權轉賬。本人同意如本人的賬戶並無足夠存款或信用額支付該等授權轉賬，本人的銀行或信用卡發卡機構有絕對酌情權不予轉賬，且本人的銀行或信用卡發卡機構可收取慣常的收費，並可隨時取消該等授權轉賬且毋須通知本人。為避免疑問，本人的銀行或信用卡發卡機構可隨時自行决定取消該等授權轉賬且毋須通知本人。</Typography>
                                        </li>
                                        <li>
                                            <Typography textAlign={"left"} fontSize={13} color={"#43474E"}>本直接付款授權將繼續生效直至另行通知為止。</Typography>
                                        </li>
                                        <li>
                                            <Typography textAlign={"left"} fontSize={13} color={"#43474E"}>本人同意，本人取消或更改本轉賬授權的任何通知，須於取消  /  更改生效日最少兩個工作天之前交予本人的銀行或信用卡發卡機構及協會。</Typography>
                                        </li>
                                    </ol>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                    <Grid item xs={12} gap={2} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                        <Button
                            type="button"
                            variant="outlined"
                            color="primary"
                            onClick={(e) => { e.preventDefault(); setEdit(false); reset(); }}
                        >
                            取消
                        </Button>
                        <Button
                            type="button"
                            variant="outlined"
                            color="primary"
                            onClick={(e) => { e.preventDefault(); setComfirmDialogOpen(true); }}
                        >
                            提交
                        </Button>
                    </Grid>
                    <Dialog
                        className={`${styles["file-input"]}`}
                        open={comfirmDialogOpen}
                        onClose={handleClose}
                        disablePortal
                        maxWidth="md"
                        PaperProps={{style:{margin:0,borderRadius:"10px"}}}
                        sx={{ borderRadius: "40px", width: "100%" }}
                    >
                        <div className={styles["confirm-dialog"]}>
                            <div className={styles["dialog-close-div"]}>
                                <CloseButton style={{ marginLeft: "auto" }} onClick={handleClose}></CloseButton>
                            </div>

                            <div className={styles["dialog-content"]}>
                                <div className={styles["info-row"]}>
                                    <h1>確認以下繳費方式詳情：</h1>
                                </div>
                                {
                                    getValues("paymentMethod") === "creditCard" &&
                                    <>
                                        <div className={styles["info-row"]}>
                                            <div className={styles["info-type"]}>信用卡類別</div>
                                            <div className={styles["info-value"]}>{ getValues("creditCardInfo.cardType") === 'visa' ? 'Visa' : '' }{ getValues("creditCardInfo.cardType") === 'master' ? 'Mastercard' : '' }</div>
                                        </div>
                                        <div className={styles["info-row"]}>
                                            <div className={styles["info-type"]}>信用卡號碼</div>
                                            <div className={styles["info-value"]}>{ getValues("creditCardInfo.creditCardNumber") }</div>
                                        </div>
                                        <div className={styles["info-row"]}>
                                            <div className={styles["info-type"]}>持卡人英文姓名</div>
                                            <div className={styles["info-value"]}>{ getValues("creditCardInfo.cardOwner") }</div>
                                        </div>
                                        <div className={styles["info-row"]}>
                                            <div className={styles["info-type"]}>持卡人聯絡號碼</div>
                                            <div className={styles["info-value"]}>{ getValues("creditCardInfo.cardOwnerMobile") }</div>
                                        </div>
                                    </>
                                }
                                {
                                    getValues("paymentMethod") === "bankTransfer" &&
                                    <>
                                        <div className={styles["info-row"]}>
                                            <div className={styles["info-type"]}>結單/存摺上的英文姓名</div>
                                            <div className={styles["info-value"]}>{ getValues("bankInfo.bankAcName") }</div>
                                        </div>
                                        <div className={styles["info-row"]}>
                                            <div className={styles["info-type"]}>銀行名稱</div>
                                            <div className={styles["info-value"]}>{ getValues("bankInfo.bankOption").replace(/_.*/, '') }</div>
                                        </div>
                                        <div className={styles["info-row"]}>
                                            <div className={styles["info-type"]}>銀行戶口號碼</div>
                                            <div className={styles["info-value"]}>{ getValues("bankInfo.bankAcNumber") }</div>
                                        </div>
                                        <div className={styles["info-row"]}>
                                            <div className={styles["info-type"]}>銀行戶口號碼之聯絡號碼</div>
                                            <div className={styles["info-value"]}>{ getValues("bankInfo.mobilePhone") }</div>
                                        </div>
                                    </>
                                }
                                <hr style={{ color: "rgba(200, 200, 200, 1)" }} />
                                <div className={styles["info-row"]}>
                                    <h1>輸入電郵地址確認更改</h1>
                                </div>
                                <Controller
                                    name="emailAddress"
                                    control={control}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            inputProps={{ readOnly: !edit }}
                                            // rules={{ required: "電郵地址為必填項目" }}
                                            onChange={(e) => {
                                                const value = e.target.value.replace(/\s/g, ''); // Remove spaces
                                                field.onChange(value); // Save the value without space
                                            }}
                                            fullWidth
                                            label="電郵地址"
                                            error={!!errors.emailAddress}
                                            helperText={errors.emailAddress ? errors.emailAddress.message : ""}
                                            variant="filled"
                                        />
                                    )}
                                />
                            </div>
                            <div className={styles["dialog-actions"]}>
                                <Button onClick={handleClose}>取消</Button>
                                <Button
                                    type="button"
                                    variant="outlined"
                                    color="primary"
                                    size="medium"
                                    disabled={loading}
                                    onClick={checkEmailAddressChanged}
                                >
                                    儲存
                                </Button>
                            </div>
                        </div>
                    </Dialog>
                    <Dialog
                        className={`${styles["file-input"]}`}
                        open={emailChangedDialogOpen}
                        onClose={handleEmailChangedDialogClose}
                        disablePortal
                        maxWidth="md"
                        PaperProps={{style:{margin:0,borderRadius:"10px"}}}
                        sx={{ borderRadius: "40px", width: "100%" }}
                    >
                        <div className={styles["confirm-dialog"]}>
                            <div className={styles["dialog-close-div"]}>
                                <CloseButton style={{ marginLeft: "auto" }} onClick={handleEmailChangedDialogClose}></CloseButton>
                            </div>

                            <div className={styles["dialog-content"]}>
                                <div className={styles["info-row"]}>
                                    請留意，您輸入的電郵地址和訂戶資料紀錄不乎。請確認以上輸入為您最常用的電郵地址，點擊“確定”將會覆寫此電郵地址至訂戶資料。
                                </div>
                            </div>
                            <div className={styles["dialog-actions"]}>
                                <Button onClick={handleEmailChangedDialogClose}>取消</Button>
                                <Button
                                    type="submit"
                                    variant="outlined"
                                    color="primary"
                                    size="medium"
                                    disabled={loading}
                                >
                                    確定
                                </Button>
                            </div>
                        </div>
                    </Dialog>
                </form>
            </Box>
        </>
    )
}

export default SubscriberChangePaymentMethod